import { headerHeight, toolbarHeight } from 'crazyEditor/core/globals';

export default {
  editorContainer: {
    height: `calc(100% - ${headerHeight}px)`,
    top: headerHeight,
    position: 'relative',
    transition: 'top ease-in-out.3s'
  },
  previewMode: {
    top: toolbarHeight
  }
};
